import React, { useState } from 'react';
import './openEnded.sass';
import TextareaAutosize from 'react-textarea-autosize';
import { counties } from './county';
// import PropTypes from 'prop-types';

/* Component for open-ended question types.
Takes in a question and displays a text area or dropdown for input
*/

const OpenEnded = ({ value, onChange, question, user }) => {
  const [inputLength, setInputLength] = useState(0);
  const inputLimit = question.maxLength;
  const regex = /Which County do you live in?/i;

  const shouldShowDropdown = regex.test(question.questionText);

  function handleComment(event) {
    onChange(
      { value: event.target.value, text: event.target.value },
      question.questionID,
      question.questionLevel,
    );
    setInputLength(event.target.value.length);
  }

  function handleCountyChange(e) {
    const index = e.target.value;
    const text = counties[index - 1];

    onChange({ value: index, text }, question.questionID, question.questionLevel);
  }

  question.questionText = question.questionText.replace(/\{user\}/gi, user);

  return (
    <div className="open-ended-container">
      <h4 className="range-score-question">
        <p className="question-text" dangerouslySetInnerHTML={{ __html: question.questionText }} />
      </h4>

      {question.questionText !== 'You have already completed this survey.' && (
        <>
          {shouldShowDropdown ? (
            <select
              className="simple-dropdown"
              style={{ width: '100%', height: '38px', fontSize: '14px', margin: '3px' }}
              onChange={handleCountyChange}
              value={value || ''}
            >
              <option value="">Select an option</option>

              {counties.map((option, index) => (
                <option key={`${question.questionID}${index}`} value={index + 1}>
                  {option}
                </option>
              ))}
            </select>
          ) : (
            <>
              <TextareaAutosize
                maxRows={50}
                maxLength={inputLimit}
                className={`flat-text-area ${question?.error ? 'flat-text-area__error' : ''}`}
                value={value}
                placeholder="Type your answer here..."
                onChange={handleComment}
                name="comment"
                required
              />

              <div className="input-comment">
                <span style={{ color: 'crimson' }}>
                  <strong>{question?.error ? question?.errorMessage : ''} </strong>
                </span>
                <small className="character-count">
                  {inputLength} / {inputLimit}
                </small>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default OpenEnded;
